module.exports = __webpack_public_path__ + "img/082.2c33dee2.png";